/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

const liveSearchHelperDevices = {
    /**
     * Detect if the current device supports touch input.
     *
     * @returns {boolean}
     */
    isTouchDevice() {
        const devicesStore = this.$store?.devices || null

        if (devicesStore && typeof devicesStore.isTouchDevice !== 'undefined') {
            return Boolean(devicesStore.isTouchDevice)
        }

        if (typeof navigator !== 'undefined' && navigator.maxTouchPoints > 0) {
            return true
        }

        return typeof window !== 'undefined' &&
            typeof window.matchMedia === 'function' &&
            window.matchMedia('(pointer: coarse)').matches
    },
    /**
     * Watch the touch device state and call the callback.
     *
     * @param {Function} callback
     */
    watchTouchDevice(callback) {
        if (typeof callback !== 'function') {
            return
        }

        const devicesStore = this.$store?.devices || null
        if (devicesStore && typeof devicesStore.isTouchDevice !== 'undefined' && typeof this.$watch === 'function') {
            callback(Boolean(devicesStore.isTouchDevice))
            this.$watch(() => this.$store.devices?.isTouchDevice, (value) => {
                callback(Boolean(value))
            })
            return
        }

        callback(this.isTouchDevice())
    }
}

export default liveSearchHelperDevices
